import posthog from "posthog-js";
import { scan } from "react-scan";
import { enable_react_scan_flag } from "../posthog/feature_flags";

scan({
  enabled: posthog.isFeatureEnabled(enable_react_scan_flag),
});
